import ParkingLanding from "./pages/ParkingLanding";

function App() {
  return <ParkingLanding />;
}

export default App;